import { useState } from "react";

//lib
import { Field, useFormikContext } from "formik";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";

export default function Text({
  label,
  type,
  name,
  disabled,
  placeholder,
  verification,
  className,
  handleVerification,
  as,
  editData,
  value,
  setErrorStatus,
  autoFocus,
  inputMode,
  maxLength,
}) {
  const { values, errors, setFieldValue } = useFormikContext();

  const [inputFocus, setInputFocus] = useState(false);

  const handleFocus = () => {
    setInputFocus(true);
  };
  const handleBlur = () => {
    setInputFocus(false);
  };

  return (
    <article
      className={as ? `col form-group _text ${className}` : `col form-group _text`}
      style={inputFocus ? { border: "0.1rem solid #3182ce" } : {}}
    >
      {label && (
        <section className="row">
          <p className="form-label">{label}</p>
        </section>
      )}
      <section
        className={`row form-group _text ${
          errors[name] && !as ? "_errors" : "_errors2"
        }`}
      >
        {editData && as ? (
          <Field
            onFocus={handleFocus}
            onBlur={handleBlur}
            type={type ? type : "text"}
            name={name}
            label={placeholder}
            disabled={disabled}
            as={as}
            value={value}
            onChange={(e) => {
              editData(e.target.value);
              setErrorStatus(true);
            }}
            innerRef={autoFocus}
            inputMode={inputMode ? inputMode : ""}
            maxLength={maxLength ? maxLength : ''}
          />
        ) : as ? (
          <Field
            onFocus={handleFocus}
            onBlur={handleBlur}
            type={type ? type : "text"}
            name={name}
            label={placeholder}
            disabled={disabled}
            className={"focus"}
            as={as}
            innerRef={autoFocus}
            inputMode={inputMode ? inputMode : ""}
            maxLength={maxLength ? maxLength : ''}
          />
        ) : (
          <Field
            type={type ? type : "text"}
            name={name}
            placeholder={placeholder}
            disabled={disabled}
            className={`${className}`}
            innerRef={autoFocus}
            inputMode={inputMode ? inputMode : ""}
            maxLength={maxLength ? maxLength : ''}
          />
        )}
        {verification && (
          <article className="verification-button">
            <button type="button" onClick={() => handleVerification()}>
              SEND
            </button>
          </article>
        )}
      </section>
      {!as && errors && errors[name] ? (
        <p
          className="text-danger text-right no-padding error-message"
          style={{ fontSize: "13px" }}
        >
          {errors[name]}
        </p>
      ) : null}
    </article>
  );
}
